export var TOOLBARS = {
  INLINE_TEXT_TOOLBAR: 'inline-text-toolbar',
  PRIMARY_TOOLBAR: 'primary-toolbar'
};

/**
 * AI section
 */
export var AI_SECTION = {
  key: 'ai-section',
  type: 'section'
};
export var AI_VIEW_SECTION = {
  key: 'ai-view-section',
  type: 'section'
};
export var ROVO_GROUP = {
  key: 'rovo-group',
  type: 'group'
};
export var ROVO_GROUP_VIEW = {
  key: 'rovo-group-view',
  type: 'group'
};
export var ROVO_GROUP_DISPLAY_SMALL = {
  key: 'rovo-group-display-small',
  type: 'group'
};
export var IMPROVE_WRITING_GROUP = {
  key: 'improve-writing-group',
  type: 'group'
};
export var IMPROVE_WRITING_BUTTON = {
  key: 'improve-writing-button',
  type: 'button'
};
export var ROVO_HERO_BUTTON = {
  key: 'rovo-hero-button',
  type: 'button'
};
export var ROVO_MENU = {
  key: 'rovo-menu',
  type: 'menu'
};
export var ROVO_MENU_DISPLAY_SMALL = {
  key: 'rovo-menu-display-small',
  type: 'menu'
};
export var ROVO_PROMPT_MENU_SECTION = {
  key: 'rovo-prompt-menu-section',
  type: 'menu-section'
};
export var ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL = {
  key: 'rovo-prompt-menu-section-display-small',
  type: 'menu-section'
};
export var IMPROVE_WRITING_MENU_ITEM = {
  key: 'improve-writing-menu-item',
  type: 'menu-item'
};
export var MAKE_SHORTER_MENU_ITEM = {
  key: 'make-shorter-menu-item',
  type: 'menu-item'
};
export var MAKE_LONGER_MENU_ITEM = {
  key: 'make-longer-menu-item',
  type: 'menu-item'
};
export var CHANGE_TONE_NESTED_MENU = {
  key: 'change-tone-nested-menu',
  type: 'nested-menu'
};
export var SPELLING_AND_GRAMMAR_MENU_ITEM = {
  key: 'spelling-and-grammar-menu-item',
  type: 'menu-item'
};
export var CHANGE_TONE_MENU_SECTION = {
  key: 'change-tone-default-menu-section',
  type: 'menu-section'
};
export var MORE_PROFESSIONAL_MENU_ITEM = {
  key: 'more-professional-menu-item',
  type: 'menu-item'
};
export var MORE_CASUAL_MENU_ITEM = {
  key: 'more-casual-menu-item',
  type: 'menu-item'
};
export var MORE_EMPATHETIC_MENU_ITEM = {
  key: 'more-empathetic-menu-item',
  type: 'menu-item'
};
export var TRANSLATE_NESTED_MENU = {
  key: 'translate-nested-menu',
  type: 'nested-menu'
};
export var TRANSLATE_MENU_SECTION = {
  key: 'translate-menu-section',
  type: 'menu-section'
};
export var DEFINE_MENU_ITEM = {
  key: 'define-menu-item',
  type: 'menu-item'
};
export var DEFINE_GROUP = {
  key: 'define-group',
  type: 'group'
};
export var DEFINE_BUTTON = {
  key: 'define-button',
  type: 'button'
};

/**
 * Text section
 */
export var TEXT_SECTION = {
  key: 'text-section',
  type: 'section'
};
export var TEXT_SECTION_PRIMARY_TOOLBAR = {
  key: 'text-section-primary-toolbar',
  type: 'section'
};

/*
 * Text section collapsed
 * - Used to control responsive menu
 */
export var TEXT_SECTION_COLLAPSED = {
  key: 'text-section-collapsed',
  type: 'section'
};
export var TEXT_COLLAPSED_GROUP = {
  key: 'text-collapsed-group',
  type: 'group'
};
export var TEXT_COLLAPSED_MENU = {
  key: 'text-collapsed-menu',
  type: 'menu'
};

/**
 * Text styles group
 */
export var TEXT_STYLES_GROUP = {
  key: 'text-styles-group',
  type: 'group'
};
export var TEXT_STYLES_MENU = {
  key: 'text-styles-menu',
  type: 'menu'
};
export var TEXT_STYLES_MENU_SECTION = {
  key: 'text-styles-menu-section',
  type: 'menu-section'
};
export var NORMAL_TEXT_MENU_ITEM = {
  key: 'normal-text-menu-item',
  type: 'menu-item'
};
export var HEADING_1_MENU_ITEM = {
  key: 'heading-1-menu-item',
  type: 'menu-item'
};
export var HEADING_2_MENU_ITEM = {
  key: 'heading-2-menu-item',
  type: 'menu-item'
};
export var HEADING_3_MENU_ITEM = {
  key: 'heading-3-menu-item',
  type: 'menu-item'
};
export var HEADING_4_MENU_ITEM = {
  key: 'heading-4-menu-item',
  type: 'menu-item'
};
export var HEADING_5_MENU_ITEM = {
  key: 'heading-5-menu-item',
  type: 'menu-item'
};
export var HEADING_6_MENU_ITEM = {
  key: 'heading-6-menu-item',
  type: 'menu-item'
};
export var BLOCK_QUOTE_MENU_ITEM = {
  key: 'block-quote-menu-item',
  type: 'menu-item'
};

/**
 * Text formatting group
 */
export var TEXT_FORMATTING_GROUP = {
  key: 'text-formatting-group',
  type: 'group'
};
export var TEXT_FORMATTING_GROUP_COLLAPSED = {
  key: 'text-formatting-group-collapsed',
  type: 'group'
};
export var TEXT_FORMATTING_GROUP_INLINE = {
  key: 'text-formatting-group-inline',
  type: 'group'
};
export var BOLD_BUTTON_GROUP = {
  key: 'bold-button-group',
  type: 'group'
};
export var UNDERLINE_BUTTON_GROUP = {
  key: 'underline-button-group',
  type: 'group'
};
export var TEXT_FORMATTING_HERO_BUTTON = {
  key: 'text-formatting-hero-button',
  type: 'button'
};
export var TEXT_FORMATTING_HERO_BUTTON_COLLAPSED = {
  key: 'text-formatting-hero-button-collapsed',
  type: 'button'
};
export var BOLD_BUTTON = {
  key: 'bold-button',
  type: 'button'
};
export var UNDERLINE_BUTTON = {
  key: 'underline-button',
  type: 'button'
};
export var TEXT_FORMATTING_MENU = {
  key: 'text-formatting-menu',
  type: 'menu'
};
export var BOLD_MENU_ITEM = {
  key: 'bold-menu-item',
  type: 'menu-item'
};
export var ITALIC_MENU_ITEM = {
  key: 'italic-menu-item',
  type: 'menu-item'
};
export var UNDERLINE_MENU_ITEM = {
  key: 'underline-menu-item',
  type: 'menu-item'
};
export var STRIKE_MENU_ITEM = {
  key: 'strike-menu-item',
  type: 'menu-item'
};
export var CODE_MENU_ITEM = {
  key: 'code-menu-item',
  type: 'menu-item'
};
export var SUBSCRIPT_MENU_ITEM = {
  key: 'subscript-menu-item',
  type: 'menu-item'
};
export var SUPERSCRIPT_MENU_ITEM = {
  key: 'superscript-menu-item',
  type: 'menu-item'
};
export var TEXT_FORMATTING_MENU_SECTION = {
  key: 'text-formatting-menu-section',
  type: 'menu-section'
};
export var CLEAR_FORMARTTING_MENU_SECTION = {
  key: 'clear-formatting-menu-section',
  type: 'menu-section'
};
export var CLEAR_FORMATTING_MENU_ITEM = {
  key: 'clear-formatting-menu-item',
  type: 'menu-item'
};

/**
 * Text color and Highlight color section
 */

export var TEXT_COLOR_HIGHLIGHT_GROUP = {
  key: 'text-color-highlight-group',
  type: 'group'
};
export var TEXT_COLOR_HIGHLIGHT_MENU = {
  key: 'text-color-highlight-menu',
  type: 'menu'
};
export var TEXT_COLOR_HIGHLIGHT_MENU_SECTION = {
  key: 'text-color-highlight-menu-section',
  type: 'menu-section'
};
export var TEXT_COLOR_MENU_ITEM = {
  key: 'text-color-menu-item',
  type: 'menu-item'
};
export var HIGHLIGHT_MENU_ITEM = {
  key: 'highlight-menu-item',
  type: 'menu-item'
};
export var CLEAR_COLOR_MENU_ITEM = {
  key: 'clear-color-menu-item',
  type: 'menu-item'
};

/*
 * Alignment
 */

export var ALIGNMENT_GROUP = {
  key: 'alignment-group',
  type: 'group'
};
export var ALIGNMENT_MENU = {
  key: 'alignment-menu',
  type: 'menu'
};
export var ALIGNMENT_MENU_SECTION = {
  key: 'alignment-menu-section',
  type: 'menu-section'
};
export var ALIGN_LEFT_MENU_ITEM = {
  key: 'align-left-menu-item',
  type: 'menu-item'
};
export var ALIGN_CENTER_MENU_ITEM = {
  key: 'align-center-menu-item',
  type: 'menu-item'
};
export var ALIGN_RIGHT_MENU_ITEM = {
  key: 'align-right-menu-item',
  type: 'menu-item'
};

/*
 * Lists and indentation group
 */
export var LISTS_INDENTATION_GROUP = {
  key: 'lists-indentation-group',
  type: 'group'
};
export var LISTS_INDENTATION_GROUP_COLLAPSED = {
  key: 'lists-indentation-group-collapsed',
  type: 'group'
};
export var LISTS_INDENTATION_GROUP_INLINE = {
  key: 'lists-indentation-group-inline',
  type: 'group'
};
export var BULLETED_LIST_BUTTON_GROUP = {
  key: 'bullet-list-button-group',
  type: 'group'
};
export var BULLETED_LIST_BUTTON = {
  key: 'bullet-list-button',
  type: 'button'
};
export var LISTS_INDENTATION_HERO_BUTTON_COLLAPSED = {
  key: 'lists-indentation-hero-button-collapsed',
  type: 'button'
};
export var LISTS_INDENTATION_HERO_BUTTON = {
  key: 'lists-indentation-hero-button',
  type: 'button'
};
export var LISTS_INDENTATION_MENU = {
  key: 'lists-indentation-menu',
  type: 'menu'
};
export var LISTS_INDENTATION_MENU_SECTION = {
  key: 'lists-indendation-menu-section',
  type: 'menu-section'
};
export var BULLETED_LIST_MENU_ITEM = {
  key: 'bullet-list-menu-item',
  type: 'menu-item'
};
export var NUMBERED_LIST_MENU_ITEM = {
  key: 'numbered-list-menu-item',
  type: 'menu-item'
};
export var TASK_LIST_MENU_ITEM = {
  key: 'task-list-menu-item',
  type: 'menu-item'
};
export var INDENT_MENU_ITEM = {
  key: 'indent-menu-item',
  type: 'menu-item'
};
export var OUTDENT_MENU_ITEM = {
  key: 'outdent-menu-item',
  type: 'menu-item'
};

/*
 * Insert block section
 */

export var INSERT_BLOCK_SECTION = {
  key: 'insert-block-section',
  type: 'section'
};
export var CODE_BLOCK_GROUP = {
  key: 'code-block-group',
  type: 'group'
};
export var CODE_BLOCK_BUTTON = {
  key: 'code-block-button',
  type: 'button'
};
export var TASK_LIST_GROUP = {
  key: 'task-list-group',
  type: 'group'
};
export var TASK_LIST_BUTTON = {
  key: 'task-list-button',
  type: 'button'
};
export var MEDIA_GROUP = {
  key: 'media-group',
  type: 'group'
};
export var MEDIA_BUTTON = {
  key: 'media-button',
  type: 'button'
};
export var MENTION_GROUP = {
  key: 'mention-group',
  type: 'group'
};
export var MENTION_BUTTON = {
  key: 'mention-button',
  type: 'button'
};
export var EMOJI_GROUP = {
  key: 'emoji-group',
  type: 'group'
};
export var EMOJI_BUTTON = {
  key: 'emoji-button',
  type: 'button'
};
export var LAYOUT_GROUP = {
  key: 'layout-group',
  type: 'group'
};
export var LAYOUT_BUTTON = {
  key: 'layout-button',
  type: 'button'
};
export var TABLE_GROUP = {
  key: 'table-group',
  type: 'group'
};
export var TABLE_BUTTON = {
  key: 'table-button',
  type: 'button'
};
export var TABLE_SIZE_PICKER = {
  key: 'table-size-picker',
  type: 'button'
};
export var INSERT_GROUP = {
  key: 'insert-group',
  type: 'group'
};
export var INSERT_BUTTON = {
  key: 'insert-button',
  type: 'button'
};

/*
 * Linking section
 */

export var LINKING_SECTION = {
  key: 'linking-section',
  type: 'section'
};
export var LINKING_GROUP = {
  key: 'linking-group',
  type: 'group'
};
export var LINKING_BUTTON = {
  key: 'linking-button',
  type: 'button'
};

/**
 * Collab section
 */
export var COLLAB_SECTION = {
  key: 'collab-section',
  type: 'section'
};
export var COMMENT_GROUP = {
  key: 'comment-group',
  type: 'group'
};
export var COMMENT_HERO_BUTTON = {
  key: 'comment-hero-button',
  type: 'button'
};

/**
 * Apps section
 */

export var APPS_SECTION = {
  key: 'apps-section',
  type: 'section'
};

/**
 * Track Changes Section
 */
export var TRACK_CHANGES_SECTION = {
  key: 'track-changes-section',
  type: 'section'
};
export var UNDO_CHANGES_GROUP = {
  key: 'undo-changes-group',
  type: 'group'
};
export var UNDO_BUTTON = {
  key: 'undo-button',
  type: 'button'
};
export var REDO_CHANGES_GROUP = {
  key: 'redo-changes-group',
  type: 'group'
};
export var REDO_BUTTON = {
  key: 'redo-button',
  type: 'button'
};
export var TRACK_CHANGES_GROUP = {
  key: 'track-changes-group',
  type: 'group'
};
export var TRACK_CHANGES_BUTTON = {
  key: 'track-changes-button',
  type: 'button'
};

/**
 * Overflow section
 */

export var OVERFLOW_SECTION = {
  key: 'overflow-section',
  type: 'section'
};
export var OVERFLOW_GROUP = {
  key: 'overflow-group',
  type: 'group'
};
export var OVERFLOW_MENU = {
  key: 'overflow-menu',
  type: 'menu'
};
export var PIN_MENU_SECTION = {
  key: 'pin-menu-section',
  type: 'menu-section'
};
export var PIN_MENU_ITEM = {
  key: 'pin-menu-item',
  type: 'menu-item'
};

/**
 * Overflow section in primary toolbar
 */
export var OVERFLOW_SECTION_PRIMARY_TOOLBAR = {
  key: 'overflow-section-primary-toolbar',
  type: 'section'
};
export var OVERFLOW_GROUP_PRIMARY_TOOLBAR = {
  key: 'overflow-group-primary-toolbar',
  type: 'group'
};
export var OVERFLOW_MENU_PRIMARY_TOOLBAR = {
  key: 'overflow-menu-primary-toolbar',
  type: 'menu'
};

/**
 * Pin section
 */
export var PIN_SECTION = {
  key: 'pin-section',
  type: 'section'
};
export var PIN_GROUP = {
  key: 'pin-group',
  type: 'group'
};
export var PIN_BUTTON = {
  key: 'pin-button',
  type: 'button'
};

/**
 * Loom section
 */

export var LOOM_MENU_SECTION = {
  key: 'loom-menu-section',
  type: 'menu-section'
};
export var LOOM_MENU_ITEM = {
  key: 'loom-menu-item',
  type: 'menu-item'
};

/**
 * Selection extensions
 */
export var SELECTION_EXTENSION_MENU_SECTION = {
  key: 'selection-extension-menu-section',
  type: 'menu-section'
};